import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

@Injectable()
export class V3RedirectGuard implements CanActivate {
  canActivate(): boolean {
    // Check if running on localhost
    const isLocalhost = window.location.hostname === 'localhost' || 
                        window.location.hostname === '127.0.0.1';    
    if (isLocalhost) {
      return true;
    }
    
    window.location.href = 'https://dxp.iti-digital.com';
    return false;
  }
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/guards/redirect.to.v3.guard.ts